import Limpar from '@mui/icons-material/Clear';
import { Box, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import ModalConfirmacao from './ModalConfirmacao';

class ProcessoApregoado extends ReactComponent {
    abrirConfirmacao = false;
    abrirConfirmacaoPlanilha = false;

    handleClickProcessoApregoado = () => {
        if (!this.observableProps.semAcao && this.sessaoStore.processoApregoado) {
            const achouFiltrados = this.salaSessaoStore.processosFiltrados.find((proc) => {
                return this.sessaoStore.processoApregoado.processo.numeroCompleto === proc.processo.numeroCompleto;
            });
            const achouSessao = this.salaSessaoStore.processosSessao.find((proc) => {
                return this.sessaoStore.processoApregoado.processo.numeroCompleto === proc.processo.numeroCompleto;
            });

            if (achouFiltrados) {
                this.store.processoExpandido = this.sessaoStore.processoApregoado;
                this.salaSessaoStore.processoScroll = this.sessaoStore.processoApregoado;
            } else if (achouSessao) {
                this.salaSessaoStore.processoModal = this.sessaoStore.processoApregoado;
            } else {
                this.mensagemStore.abrirMensagemAlerta('Processo não está na sessão.');
            }
        }
    };

    cancelarPregao = () => {
        this.abrirConfirmacao = true;
    };

    cancelarPregaoLote = () => {
        this.abrirConfirmacaoPlanilha = true;
    };

    fecharDialogConfirmacao = () => {
        this.abrirConfirmacao = false;
    };

    fecharDialogConfirmacaoLote = () => {
        this.abrirConfirmacaoPlanilha = false;
    };

    cancelarProcessoApregoado = () => {
        this.salaSessaoStore.cancelarPregao();
        this.abrirConfirmacao = false;
    };

    cancelarPregaoPlanilha = () => {
        this.sessaoService.cancelarPregaoLote(
            this.sessaoStore.sessaoSelecionada.id.split('----')[0],
            this.salaSessaoStore.getRelator(this.sessaoStore.relatorPregaoLote)
        );
        this.abrirConfirmacaoPlanilha = false;
    };

    get numeroProcesso() {
        return this.sessaoStore.processoApregoado?.processo?.numeroCompleto;
    }

    constructor(props) {
        super(props);

        // eslint-disable-next-line mobx/exhaustive-make-observable
        makeObservable(this, {
            abrirConfirmacao: observable,
            abrirConfirmacaoPlanilha: observable,
            handleClickProcessoApregoado: action,
            cancelarPregao: action,
            cancelarPregaoLote: action,
            fecharDialogConfirmacao: action,
            fecharDialogConfirmacaoLote: action,
            cancelarProcessoApregoado: action,
            cancelarPregaoPlanilha: action,
            numeroProcesso: computed,
            labelRelator: computed,
            corDoTexto: computed
        });
    }

    get labelRelator() {
        return this.salaSessaoStore.getLabelRelator(this.sessaoStore.relatorPregaoLote);
    }

    get corDoTexto() {
        return this.observableProps.corDoTexto ?? 'white';
    }

    render() {
        return (
            <Typography
                variant="h6"
                style={{ fontSize: '17px', marginLeft: '10px', zIndex: '1' }}
            >
                {this.sessaoStore.processoApregoado ? (
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                        <Tooltip title={!this.observableProps.semAcao && <Typography>Abrir processo</Typography>}>
                            <Box
                                style={{
                                    cursor: this.observableProps.semAcao ? 'auto' : 'pointer',
                                    lineHeight: '1.25'
                                }}
                                onClick={this.handleClickProcessoApregoado}
                            >
                                <Typography
                                    display={'inline'}
                                    style={{ color: this.corDoTexto }}
                                >
                                    Apregoado:&nbsp;
                                </Typography>
                                <Typography
                                    display={'inline'}
                                    style={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '300px',
                                        color:
                                            this.sessaoStore.processoApregoado &&
                                            this.store.processoExpandido &&
                                            this.sessaoStore.processoApregoado.processo.numeroCompleto.includes(
                                                this.salaSessaoStore.processoExpandido.processo.numeroCompleto
                                            )
                                                ? this.corDoTexto
                                                : '#ffb74d',
                                        marginLeft: '6px'
                                    }}
                                >
                                    {this.sessaoStore.processoApregoado.processo.numeroCompleto}
                                </Typography>
                            </Box>
                        </Tooltip>
                        <Tooltip title={<Typography>Cancelar pregão</Typography>}>
                            <Box style={{ display: 'flex', alignItems: 'center', marginLeft: '5px' }}>
                                <Limpar
                                    onClick={this.cancelarPregao}
                                    style={{ cursor: 'pointer', color: this.corDoTexto }}
                                    className="corBotaoAmarelo"
                                />
                            </Box>
                        </Tooltip>
                    </Box>
                ) : (
                    this.sessaoStore.relatorPregaoLote && (
                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                            <Box style={{ cursor: 'pointer' }}>
                                <Typography
                                    display={'inline'}
                                    style={{ color: this.corDoTexto }}
                                >
                                    Apregoado:&nbsp;
                                </Typography>
                                <Typography
                                    display={'inline'}
                                    style={{ color: '#ffb74d' }}
                                >
                                    Planilha - {this.labelRelator}
                                </Typography>
                            </Box>
                            <Tooltip title={<Typography>Cancelar pregão de planilha</Typography>}>
                                <Box style={{ display: 'flex', alignItems: 'center', marginLeft: '5px' }}>
                                    <Limpar
                                        onClick={this.cancelarPregaoLote}
                                        style={{ cursor: 'pointer', color: this.corDoTexto }}
                                        className="corBotaoAmarelo"
                                    />
                                </Box>
                            </Tooltip>
                        </Box>
                    )
                )}
                <ModalConfirmacao
                    titulo={'Cancelamento de pregão de processo'}
                    open={this.abrirConfirmacao}
                    callbackCancelar={this.fecharDialogConfirmacao}
                    callbackConfirmar={this.cancelarProcessoApregoado}
                >
                    <Typography display={'inline'}>Cancelar o pregão do processo </Typography>
                    <Typography
                        display={'inline'}
                        fontWeight={'bold'}
                    >
                        {this.numeroProcesso}
                    </Typography>
                    <Typography display={'inline'}>?</Typography>
                </ModalConfirmacao>
                <ModalConfirmacao
                    titulo={'Cancelamento de pregão de planilha'}
                    open={this.abrirConfirmacaoPlanilha}
                    callbackCancelar={this.fecharDialogConfirmacaoLote}
                    callbackConfirmar={this.cancelarPregaoPlanilha}
                >
                    <Typography display={'inline'}>Cancelar o pregrão da planilha de processos do relator </Typography>
                    <Typography
                        display={'inline'}
                        fontWeight={'bold'}
                    >
                        {this.labelRelator}
                    </Typography>
                    <Typography display={'inline'}>?</Typography>
                </ModalConfirmacao>
                {!this.sessaoStore.processoApregoado && !this.sessaoStore.relatorPregaoLote && (
                    <Tooltip title={<Typography>Apregoamento</Typography>}>
                        <Typography
                            display={'inline'}
                            style={{ color: this.corDoTexto, display: 'flex', alignContent: 'center' }}
                        >
                            Nenhum processo apregoado
                        </Typography>
                    </Tooltip>
                )}
            </Typography>
        );
    }
}

export default inject('stores')(observer(ProcessoApregoado));
